import { FC } from "react"

import { DateTime } from "luxon"

import { buildCssClassName } from "@/3514/utils"

interface IProps {
    className?: string
}

const DateWidget: FC<IProps> = ({ className }) => {
    return (
        <p className={buildCssClassName({ [className]: className, "fs-14-regular": !className })}>
            {DateTime.now().toFormat("EEEE, MMMM dd")}
        </p>
    )
}

export default DateWidget
